/* Publish by EComposer at 2026-10-29 06:09:24*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ghfzdv2z0w5"]=  window.__ectimmers["ecom-ghfzdv2z0w5"] || {};
let e=this.$el.querySelector(".ecom-shopify__article__description-view-more-btn"),r=this.settings.content_type,s=this.$el.querySelector(".ecom-shopify__article__description--full"),l=this.$el.querySelector(".ecom-shopify__article__description--paragraph");e&&e.addEventListener("click",function(){r==="text"&&s?(s.style.display="inherit",l.style.display="none"):l.style.maxHeight=null,this.style.display="none"})

                    });
                    
                        document.querySelectorAll('.ecom-ghfzdv2z0w5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ghfzdv2z0w5', settings: {"content_type":"html"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}